import moment from "moment/moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { succsesDataChangeAlert, succsesDataDeleteAlert } from "../../alerts/alerts";
import ModalProductInfo from "../../components/modals/modalProductInfo/ModalProductInfo";
import { PaginatedItems } from "../../components/pagination/Pagination";
import useDebounse from "../../helpers/useDebounse";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";

const RepairsServiceVifi = () => {
    const storeId = 38;
    const { id } = useParams();
    const actionSelectStyle = { width: "216px" };
    const actionButtonStyle = { width: "128px" };

    const permissions = useSelector((state) => state.status.permissions);
    const userPermission = useSelector((state) => state.status.userPermission);
    const isMaster = +userPermission?.user_permission_type_id === 2;
    const canEditRepairs = permissions.includes("repair_edit") || permissions.includes("all");
    const canWriteOffParts = canEditRepairs && [3, 9].includes(+userPermission?.user_permission_type_id);
    const canViewMastersFilter = !!userPermission?.id && !isMaster;
    const canAssignMaster = canEditRepairs && !isMaster;
    const canShowActions = canAssignMaster || canWriteOffParts;

    const [currentPage, setCurrentPage] = useState(1);
    const [productList, setProductList] = useState([]);
    const [search, setSearch] = useState("");
    const [showProductModal, setShowProductModal] = useState(false);
    const [dataForModal, setDataForModal] = useState([]);
    const [selectedMaster, setSelectedMaster] = useState("");

    const debounceSearch = useDebounse(search, 1000);

    const searchQwery = search.length > 0 ? `&search=${debounceSearch}` : "";
    const pagination = "&page=" + currentPage;
    const productsStoreIds = "&is_show_in_services=1";
    const currentMasterId = isMaster ? userPermission?.id : id;
    const masterPrams = +currentMasterId ? "&purpose=masters&master_id=" + currentMasterId : "&purpose=masters";

    const productsParamsCombiner = searchQwery + pagination + productsStoreIds + masterPrams;

    const { data: masters, refetch: refetchMasters } = useGetPageQuery("users/masters?services=1&store_id=" + storeId);
    const { data: products, refetch: refetchProducts } = useGetPageQuery("products?move=1&" + productsParamsCombiner, {
        skip: !userPermission?.id,
    });

    const [deleteRetairs, { isLoading, isError }] = useSendFormMutation();
    const [assignMaster, { isLoading: isAssignMasterLoading }] = useSendFormMutation();

    const openModalHandler = (product) => {
        setDataForModal(product);
        setShowProductModal(true);
    };

    const checkAllHandler = () => {
        setProductList(products.data.map((user) => user.id.toString()));
    };

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setProductList([...productList, e.target.value]);
        } else if (!e.target.checked) {
            setProductList([...productList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteProductsHandler = async () => {
        for (const product of productList) {
            await deleteRetairs({
                body: {},
                url: "products/" + product + "/spare-parts",
                method: "POST",
            });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchProducts();
    };

    const assignMasterHandler = async () => {
        if (!productList.length) {
            alert("Оберіть товари");
            return;
        }

        if (!selectedMaster) {
            alert("Оберіть майстра");
            return;
        }

        const response = await assignMaster({
            body: {
                product_ids: productList.map((productId) => Number(productId)),
                master_id: Number(selectedMaster),
            },
            url: "products/assign-master",
            method: "POST",
        });

        if (!response.error) {
            succsesDataChangeAlert();
            setProductList([]);
            await refetchMasters();
            await refetchProducts();
        }
    };

    return (
        <>
            {masters && products && (
                <div className="content">
                    {dataForModal && (
                        <ModalProductInfo
                            showProductModal={showProductModal}
                            setShowProductModal={setShowProductModal}
                            dataForModal={dataForModal}
                        />
                    )}
                    <div className="col-12">
                        <div className="header-container mb-3">
                            <div className="header">
                                <h1>Сервісний центр {products.total} товарів</h1>
                            </div>
                            <div className="header-functions no-print">
                                <div className="float-end mx-2 my-2">
                                    <Link className="btn btn-primary" onClick={() => window.print()}>
                                        Друк звіту
                                    </Link>
                                </div>
                                <div className="float-end  mx-2 my-2 no-print">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Пошук..."
                                            onChange={(e) => setSearch(e.target.value)}
                                            value={search}
                                        />
                                        <button className="btn btn-outline-secondary" type="button" id="button-addon2">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                {canViewMastersFilter && (
                                    <>
                                        <Link
                                            to={"/repairs_service/0"}
                                            className={
                                                +id === 0
                                                    ? "btn btn-info mb-1 mx-1 no-print"
                                                    : "btn btn-primary mb-1 mx-1 no-print"
                                            }
                                        >
                                            Всі
                                        </Link>
                                        {masters.map((master) => {
                                            return (
                                                <Link
                                                    key={master.id}
                                                    to={"/repairs_service/" + master.id}
                                                    className={
                                                        +id === master.id
                                                            ? "btn btn-info mb-1 mx-1 no-print"
                                                            : "btn btn-primary mb-1 mx-1 no-print"
                                                    }
                                                    onClick={() => setCurrentPage(1)}
                                                >
                                                    {`${master.name} (${master.count})`}
                                                </Link>
                                            );
                                        })}
                                    </>
                                )}
                                <div id="list_form">
                                    <a className="check_all no-print" onClick={checkAllHandler}>
                                        Виділити все
                                    </a>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th data-field="check" className="no-print"></th>
                                                <th data-field="id" className="no-mobile">
                                                    ID
                                                </th>
                                                <th data-field="user_name">Назва</th>
                                                <th data-field="user_name">Стан</th>
                                                <th data-field="user_address">Майстер</th>
                                                <th data-field="user_imei" className="no-mobile">
                                                    IMEI
                                                </th>
                                                <th data-field="user_address">Ціна</th>
                                                <th data-field="user_date" className="no-mobile">
                                                    Створено
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {products.data.map((product) => {
                                                return (
                                                    <tr key={product.id}>
                                                        <td className="check_area text-right">
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={productList.includes(
                                                                        product.id.toString(),
                                                                    )}
                                                                    value={product.id}
                                                                    onChange={(e) => listCheckHandler(e)}
                                                                />
                                                                <label className="custom-control-label">&nbsp;</label>
                                                            </div>
                                                        </td>
                                                        <td className="no-mobile fit">#{product.id}</td>
                                                        <td>
                                                            <a
                                                                className="fake-a"
                                                                onClick={() => openModalHandler(product)}
                                                            >
                                                                {product.title} (
                                                                {product.imei_sn.slice(product.imei_sn.length - 5)})
                                                            </a>
                                                            <div></div>
                                                        </td>
                                                        <td>
                                                            <div className="note note-status">{product.status}</div>
                                                        </td>
                                                        <td>{product?.master?.name}</td>
                                                        <td className="fit no-mobile">{product.imei_sn}</td>
                                                        <td className="fit">{product.price}&nbsp;грн</td>
                                                        <td className="fit no-mobile">
                                                            {moment(product.created_at).format("DD.MM.YYYY")}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {canShowActions ? (
                                        <div className="mb-3 no-print">
                                            {canWriteOffParts && (
                                                <div className="d-flex gap-3 mb-2">
                                                    <select
                                                        name="action"
                                                        className="form-select no-print"
                                                        style={actionSelectStyle}
                                                    >
                                                        <option value="delete">Списати на запчастини</option>{" "}
                                                    </select>
                                                    <button
                                                        className="btn btn-info no-print"
                                                        style={actionButtonStyle}
                                                        onClick={deleteProductsHandler}
                                                    >
                                                        {isLoading ? "Завантаження" : "Виконати"}
                                                    </button>
                                                </div>
                                            )}
                                            {canAssignMaster && (
                                                <div className="d-flex gap-3">
                                                    <select
                                                        name="master"
                                                        className="form-select no-print"
                                                        style={actionSelectStyle}
                                                        value={selectedMaster}
                                                        onChange={(e) => setSelectedMaster(e.target.value)}
                                                    >
                                                        <option value="">Оберіть майстра</option>
                                                        {masters.map((master) => (
                                                            <option key={master.id} value={master.id}>
                                                                {master.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button
                                                        className="btn btn-info no-print"
                                                        style={actionButtonStyle}
                                                        disabled={isAssignMasterLoading}
                                                        onClick={assignMasterHandler}
                                                    >
                                                        {isAssignMasterLoading ? "Завантаження" : "Назначити"}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : null}

                                    <nav className="no-print">
                                        <PaginatedItems
                                            pageCount={products.last_page}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default RepairsServiceVifi;
